export default {
  fontSizes: {
    sm: '13px',
    md: '16px',
    lg: '18px',
    xl: '30px',
  },
}
